import LinkedinTemplateForm from './linkedinTemplateForm.container';

export default LinkedinTemplateForm;
